
import { Component, Emit, Mixins, Watch, Ref } from 'vue-property-decorator'
import { Company } from '@/firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'
import UserCompaniesMixin from '../../mixins/UserCompaniesMixin.vue'
import store, { Actions } from '../../store'
import { navigateToCompanyHome } from '@/router'

@Component
export default class RestaurantSwitcher extends Mixins(AuthMixin, UserCompaniesMixin) {
  @Ref() public readonly select!: HTMLElement

  public currentRestaurant = {} as Company
  public restaurants: Company[] = []

  @Watch('userCompanies', {immediate: true, deep: true})
  public onUserCompaniesChanged() {
    this.restaurants = Object.values(this.userCompanies)
  }

  public addRestaurant() {
    if (this.select) {
      this.select.blur()
    }
    if (this.$route.name === 'restaurant-edit') {
      this.$router.push({name: 'restaurant-edit', params: {id: 'create'}})
      this.$router.go(0)
    } else {
      this.$router.push({name: 'restaurant-edit', params: {id: 'create'}})
    }
  }

  public restaurantDisplayText(restaurant: Company) {
    let displayText = restaurant.name
    if (restaurant.identifier) {
      displayText += ` (${restaurant.identifier})`
    } else if (restaurant.address && restaurant.address.state) {
      displayText += ` (${restaurant.address.state})`
    }
    return displayText
  }

  @Watch('userCompany', {immediate: true})
  private updateCurrentCompany() {
    this.currentRestaurant = this.restaurants.find(({id}) => id === this.userCompany.id) as Company
  }

  @Emit('updateEntry')
  public async updateEntry() {
    const [currentCompany] = await store.dispatch(Actions.SET_USER_COMPANY, this.currentRestaurant.id)
    navigateToCompanyHome(currentCompany)
  }
}

